import { Funnel } from "@phosphor-icons/react";
import { Button } from "../ui/button";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../ui/select";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "../ui/dialog";

export function FilterDialog({
  open, onOpenChange, filters, setFilter, licenseTypes,
  MANNSCHAFT_OPTIONS,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Funnel className="h-5 w-5" /> Filter
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <FilterSelect label="Geschlecht" testId="filter-dialog-geschlecht" value={filters.geschlecht} onChange={(v) => setFilter('geschlecht', v)} options={licenseTypes.geschlechter} />
          <FilterSelect label="Spieler-Lizenz" testId="filter-dialog-spieler" value={filters.spieler} onChange={(v) => setFilter('spieler', v)} options={licenseTypes.spieler_lizenzen} withOhne />
          <FilterSelect label="Mannschaft" testId="filter-dialog-mannschaft" value={filters.mannschaft} onChange={(v) => setFilter('mannschaft', v)} options={MANNSCHAFT_OPTIONS} withOhne />
          <FilterSelect label="SR-Lizenz" testId="filter-dialog-sr" value={filters.sr} onChange={(v) => setFilter('sr', v)} options={licenseTypes.schiedsrichter_lizenzen} withOhne />
          <FilterSelect label="Gültig bis" testId="filter-dialog-gueltig-bis" value={filters.gueltigBis} onChange={(v) => setFilter('gueltigBis', v)} options={licenseTypes.gueltig_bis_jahre} />
          <div className="flex gap-2 pt-2">
            <Button variant="outline" className="flex-1" onClick={() => { setFilter('geschlecht', 'ALLE'); setFilter('spieler', 'ALLE'); setFilter('sr', 'ALLE'); setFilter('gueltigBis', 'ALLE'); setFilter('mannschaft', 'ALLE'); }}>
              Zurücksetzen
            </Button>
            <Button className="flex-1" onClick={() => onOpenChange(false)}>Anwenden</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function FilterSelect({ label, testId, value, onChange, options, withOhne }) {
  return (
    <div className="space-y-2">
      <label className="text-xs uppercase tracking-wider font-semibold text-muted-foreground">{label}</label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testId} className="w-full"><SelectValue placeholder="Alle" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="ALLE">Alle</SelectItem>
          {withOhne && <SelectItem value="OHNE">Ohne</SelectItem>}
          {options.map((opt) => <SelectItem key={opt} value={opt}>{opt}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
